import { motion } from "framer-motion";
import { Scissors } from "lucide-react";
import { LOYALTY_GOAL } from "../lib/format";

export const StampGrid = ({ stamps = 0, dark = false, prefix = "stamp" }) => (
  <div data-testid={`${prefix}-grid`} className="grid grid-cols-6 gap-2 sm:gap-3">
    {Array.from({ length: LOYALTY_GOAL }, (_, i) => {
      const on = i < stamps;
      return (
        <motion.span
          key={i}
          data-testid={`${prefix}-${i + 1}`}
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: i * 0.03, type: "spring", stiffness: 260, damping: 18 }}
          className={`aspect-square rounded-full border flex items-center justify-center transition-colors duration-300 ${
            on
              ? dark ? "bg-[#F7F2EC] border-[#F7F2EC] text-[#0B1F3A]" : "bg-[#0B1F3A] border-[#0B1F3A] text-[#F7F2EC]"
              : dark ? "border-[#F7F2EC]/35 text-[#F7F2EC]/35" : "border-[rgba(11,31,58,0.25)] text-[#9A8F90]"
          }`}
        >
          {on ? <Scissors className="w-3.5 h-3.5" /> : <span className="font-mono-alt text-[10px]">{i + 1}</span>}
        </motion.span>
      );
    })}
    <span
      data-testid={`${prefix}-free`}
      className={`aspect-square rounded-full border-2 border-dashed flex items-center justify-center ${
        stamps >= LOYALTY_GOAL ? "bg-[#C2410C] border-[#C2410C] text-white" : dark ? "border-[#F7F2EC]/50 text-[#F7F2EC]/70" : "border-[#0B1F3A]/40 text-[#0B1F3A]/60"
      }`}
      title="50% di sconto"
    >
      <span className="font-mono-alt text-[10px] font-bold">−50%</span>
    </span>
  </div>
);
